<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ETxTUu/tc-custom/9780062909930.jpg?1730981217173" alt="This image is the cover for the book Boys in the Cave"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boys in the Cave
      </h1>
      <p class="bookDescription body article font2">
        <p>From award-winning ABC News Chief National Correspondent Matt Gutman, and written using exclusive interviews and information comes the definitive account of the dramatic story that gripped the world: the miracle rescue of twelve boys and their soccer coach trapped in a flooded cave miles underground for nearly three weeks—a pulse-pounding page-turner by a reporter who was there every step of their journey out. <br/><br/>After a practice in June 2018, a Thai soccer coach took a dozen of his young players to explore a famous but flood-prone cave. It was one of the boys’ birthday, but neither he nor the dozen resurfaced. Worried parents and rescuers flocked to the mouth of a cave that seemed to have swallowed the boys without a trace. Ranging in age from eleven to sixteen, the boys were all members of the Wild Boars soccer team. When water unexpectedly inundated the cave, blocking their escape, they retreated deeper inside, taking shelter in a side cavern. While the world feared them dead, the thirteen young souls survived by licking the condensation off the cave’s walls, meditating, and huddling together for warmth.</p><p>In this thrilling account, ABC News Chief National Correspondent Matt Gutman recounts this amazing story in depth and from every angle, exploring their time in the cave, the failed plans and human mistakes that nearly doomed them, and the daring mission that ultimately saved them. Gutman introduces the elite team of volunteer divers who risked death to execute a plan so risky that its American planners admitted, “for us, success would have meant getting just one boy out alive.” He takes you inside the meetings where life and death decisions were grimly made and describes how these heroes pulled off an improbable rescue under immense pressure, with the boys’ desperate parents and the entire world watching. One of the largest rescues in history was in doubt until the very last moment. </p><p>Matt Gutman covered the story intensively, went deep inside the caves himself, and interviewed dozens of rescuers, experts and eye-witnessed around the world. The result is this pulse-pounding page-turner that vividly recreates this extraordinary event in all its intensity—and documents the ingenuity and sacrifice it took to succeed. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matt Gutman
      </h2>
      
      <p class="authorDescription body article"><P>Matt Gutman is the Chief National Correspondent for ABC News, and the host of the Saturday morning show <I>Sea Rescue.</I> A veteran journalist once held captive on the job, he has spent part of his career researching and reporting on human survival against impossible odds. He lives in Los Angeles with his family. <I>The Boys in the Cave </I>is his first book.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d24457b8